import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_NON_NATIONAL_EXAM_SUMMARY_PDF } from '../../constants/apiUrls';
import { GET_NON_NATIONAL_EXAM_SUMMARY_PDF_QUERY_KEY } from '../../constants/queryKeys';

// =============================================================================
// Request & Response Model
// =============================================================================
interface GetRegistrationSummaryPDFResponse {
  url: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetRegistrationSummaryPDFResponse) => void;
  onError?: (data: AxiosError) => void;
}

export const useGetRegistrationSummaryPDF = ({ uuid, onSuccess, onError }: Input) => {
  const getRegistrationSummaryPDF = async () => {
    const res = await axiosClient.get<GetRegistrationSummaryPDFResponse>(
      GET_NON_NATIONAL_EXAM_SUMMARY_PDF(uuid)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_NON_NATIONAL_EXAM_SUMMARY_PDF_QUERY_KEY],
    getRegistrationSummaryPDF,
    {
      onSuccess,
      onError,
      enabled: false,
    },
    true,
    false
  );
};
